import React, { useState, useEffect, useRef } from 'react'
import { useParams, Link } from 'react-router-dom'
import { Input, InputGroup, Loader, Message, Modal } from 'rsuite'
// import moment from 'moment'
import {
  H1, HorizontalFlex, SendButton, VerticalFlex, BackButton,
  Title, AddToEventButton, VideoFrame, PhotoFrame, P2
} from '../Components/Activity/ActivityStyledComponents'
import { ActivitiesFav, SendTG } from '../Components/Icons'
import BriefDescriptionList from '../Components/Activity/BriefDescriptionList'
import FullDescription from '../Components/Activity/FullDescription'
import Guidelines from '../Components/Activity/Guidelines'
import Comment from '../Components/Activity/Comment'
import EditActivity from '../Components/Activity/EditActivity'
import AddToEventModal from '../Components/Activity/AddToEventModal'
import { colors } from '../Components/Styles/common-styles'
import { getActivity } from '../Context/prismic'
import { useAuth } from '../Context/Auth'
import { isActivityFavorite } from '../Context/firebase'

const inputStyles = {
  width: 318
}

const modalStyles = {
  margin: 'auto',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center'
}

const styles = {
  topic: {
    width: 318,
    marginLeft: 33
  },
  instructions: {
    margin: 0,
    textAlign: 'left',
    marginTop: '58px',
    input: {
      marginTop: '12px',
      minHeight: 130
    }
  }
}

const CustomInputGroup = ({ addComment }) => {
  const [inputText, setInputText] = useState('')
  const inputHandler = text => setInputText(text)
  const onSubmit = () => {
    if (inputText.trim()) {
      addComment(inputText)
      setInputText('')
    }
  }
  return (
    <HorizontalFlex>
      <InputGroup inside style={inputStyles}>
        <Input
          placeholder='Leave your comment here'
          value={inputText}
          onChange={inputHandler}
          onPressEnter={onSubmit}
        />
      </InputGroup>
      <SendButton
        onClick={onSubmit}
      >
        <SendTG />
      </SendButton>
    </HorizontalFlex>
  )
}

const CommentGroup = ({ comments }) => {
  const [fakeCurrentDate, setFakeCurrentDate] = useState(new Date())
  const toLastComment = useRef(null)

  useEffect(() => {
    let unmounted = false
    if (unmounted) {
      setTimeout(() => setFakeCurrentDate(new Date()), 60000)
    }
    return () => { unmounted = true }
  }, [fakeCurrentDate])

  useEffect(() => {
    if (comments.length > 5) {
      toLastComment.current.scrollIntoView({ block: 'center', behavior: 'smooth' })
    }
  })

  const formateDate = date => {
    const minutes = parseInt(date / 60000)
    if (minutes === 0) {
      return 'few seconds ago'
    } else if (minutes <= 59) {
      return `${minutes} minute(-s) ago`
    } else if (minutes > 59 && minutes < 1440) {
      return `${minutes / 60} hour(-s) ago`
    } else {
      return 'long ago'
    }
  }

  return (
    <div style={{ overflow: 'auto', maxHeight: '400px' }}>
      {comments.map((item, index) => {
        return (
          <Comment
            key={index}
            name={item.userName}
            text={item.text}
            date={formateDate(fakeCurrentDate - item.date)}
          />
        )
      })}
      <div ref={toLastComment} />
    </div>
  )
}

const Activity = props => {
  const {
    selectedActivity, setActivityPickerVisible,
    onSelectActivity, setActivityDescriptionShown,
    previewOnly, setActivityPreviewModal, withoutEditing,
    event, setEvent, data, phaseIndex
  } = props

  const [cardData, setCardData] = useState(!data ? null : data)
  const [isFav, setFav] = useState()
  const [noData, setNoData] = useState()
  const [image, setImage] = useState(!data?.data?.cover_image ? null : data.data.cover_image.thumbnail.url)
  const [videoId, setVideoId] = useState(null)
  const [comments, setComments] = useState([])
  const [isModalVisible, setModalVisible] = useState(false)
  const [isEditActivityVisible, setEditActivityVisible] = useState(false)
  const { cardId } = selectedActivity ? { cardId: selectedActivity } : useParams()
  const { currentUser } = useAuth()

  const onCommentAdd = comment => {
    setComments(prev => [
      ...prev,
      {
        date: new Date(),
        userName: currentUser.displayName,
        text: comment
      }
    ])
  }
  const getVideoId = response => {
    const url = response?.data?.video?.embed_url || null
    if (url) {
      let id = url.split('v=')[1]
      const ampersandPosition = id.indexOf('&')
      ampersandPosition !== -1 ?? (id = id.substring(0, ampersandPosition))
      return id
    }
  }
  useEffect(() => {
    const fetchData = async () => {
      const activity = await getActivity(cardId)
      if (activity) {
        const isFavorite = await isActivityFavorite(cardId)
        setNoData(false)
        setCardData({ data: activity })
        setImage(activity?.cover_image?.thumbnail?.url)
        setVideoId(getVideoId({ data: activity }))
        setFav(isFavorite)
      } else {
        setNoData(true)
      }
    }
    if (!cardData) {
      fetchData()
    }
  }, [])
  return (
    <>
      {noData && <Message
        showIcon
        type='error'
        title='404'
        description='No such card id, this url is unavailable'
      />}
      {isEditActivityVisible
        ? <EditActivity
          setActivityPreviewModal={setActivityPreviewModal}
          isFav={isFav}
          videoId={videoId}
          image={image}
          event={event}
          phaseIndex={phaseIndex}
          setEvent={setEvent}
          data={cardData}
        />
        : <div style={{ marginLeft: '49px' }}>
          {cardData !== null &&
            <VerticalFlex>
              {selectedActivity && !previewOnly
                ? <Link to='/create' style={{ width: '200px' }}>
                  <BackButton
                    style={{ padding: '14px 0' }}
                    onClick={e => {
                      e.preventDefault()
                      setActivityDescriptionShown(false)
                    }}
                  > &#8592; Back to all activities</BackButton>
                </Link>
                : !previewOnly
                  ? <Link to='/activities' style={{ width: '200px' }}>
                    <BackButton style={{ padding: '14px 0' }}> &#8592; Back to all activities</BackButton>
                  </Link>
                  : <BackButton
                    style={{ margin: '14px 0', display: 'flex', width: '170px' }}
                    onClick={
                      () => setActivityPreviewModal(false)
                    }
                  > &#8592; Back to my event</BackButton>}

              <div style={{ marginTop: '9px', marginBottom: '22px', display: 'flex', justifyContent: 'space-between' }}>
                {!cardData.data.topic
                  ? <div style={{ display: 'flex', alignItems: 'center', paddingLeft: 20 }}>
                    <ActivitiesFav
                      fill={isFav ? colors.orange : colors.grey}
                    />
                    <Title>{cardData?.data?.title[0]?.text || ''}</Title>
                  </div>
                  : <div style={{ display: 'flex', alignItems: 'center', marginTop: '9px', marginBottom: '22px' }}>
                    <P2>Topic:</P2>
                    <InputGroup inside style={styles.topic} onClick={e => e.stopPropagation()}>
                      <Input
                        placeholder='e.g. Discussing today’s agenda'
                        value={cardData.data.topic}
                      />
                    </InputGroup>
                  </div>}
                {!previewOnly
                  ? <AddToEventButton
                    style={{ margin: '0 14px' }}
                    onClick={
                      selectedActivity
                        ? () => { // if clicked from modal from CreateEvent.jsx / EditEvent.jsx
                          onSelectActivity && onSelectActivity(selectedActivity)
                          setActivityPickerVisible(false)
                          setActivityDescriptionShown(false)
                        }
                        : () => { // if clicked from Activity.jsx
                          setModalVisible(true)
                        }
                    }
                  > Add to event </AddToEventButton>
                  : !withoutEditing
                    ? <AddToEventButton // ref to edit activity page
                      style={{ margin: '0 14px' }}
                      onClick={
                        () => { // if clicked from Activity.jsx
                          setEditActivityVisible(true)
                        }
                      }
                    > Edit </AddToEventButton>
                    : <></>}
              </div>

              <HorizontalFlex>
                <Modal
                  style={modalStyles}
                  show={isModalVisible}
                  onHide={() => setModalVisible(false)}
                >
                  <AddToEventModal
                    activityName={cardData?.data?.title[0]?.text}
                    activity={cardData?.data}
                  />
                </Modal>
                <VerticalFlex>
                  {videoId
                    ? <VideoFrame src={`https://www.youtube.com/embed/${videoId}?feature=oembed}`} />
                  // ? <VideoFrame src='https://www.youtube.com/embed/5qap5aO4i9A?feature=oembed' />
                  // ? <VideoFrame src={video} /> // console.log(video) => https://www.youtube.com/watch?v=5qap5aO4i9A
                    : image && <PhotoFrame src={image} />}
                  <BriefDescriptionList
                    cardDataBriefDescription={cardData?.data}
                  />
                  {cardData?.data?.instructions
                    ? <div style={styles.instructions}>
                      <P2>Participant's instructions</P2>
                      <InputGroup inside style={styles.instructions.input} onClick={e => e.stopPropagation()}>
                        <Input
                          componentClass='textarea'
                          value={cardData.data.instructions}
                        />
                      </InputGroup>
                    </div>
                    : null}
                </VerticalFlex>

                <VerticalFlex>
                  {cardData.data.topic
                    ? <div style={{ display: 'flex', alignItems: 'center', paddingLeft: 20 }}>
                      <ActivitiesFav
                        fill={isFav ? colors.orange : colors.grey}
                      />
                      <Title>{cardData?.data.title[0]?.text || ''}</Title>
                    </div> : null}
                  <FullDescription
                    cardDataFullDescription={cardData?.data?.description}
                    cardDataGoals={cardData?.data?.goals}
                    cardDataPreparation={cardData?.data?.preparation}
                    cardDataRequisites={cardData?.data?.requisites}
                  />
                </VerticalFlex>
              </HorizontalFlex>

              <div style={{ marginTop: '58px' }}>
                <HorizontalFlex>
                  {!previewOnly
                    ? <VerticalFlex>
                      <H1 style={{ width: '370px', marginBottom: '28px' }}>
                        Comments ({comments.length})
                      </H1>
                      <CommentGroup comments={comments} />
                      <CustomInputGroup addComment={onCommentAdd} />
                    </VerticalFlex>
                    : <VerticalFlex>
                      <H1 style={{ width: '370px', marginBottom: '28px' }} />
                    </VerticalFlex>}

                  <VerticalFlex>
                    <Guidelines
                      cardDataSteps={cardData?.data?.steps}
                    />
                  </VerticalFlex>
                </HorizontalFlex>
              </div>
            </VerticalFlex>}
          {cardData === null &&
          noData === undefined &&
            <Loader backdrop size='lg' content='loading...' vertical />}
        </div>}
    </>
  )
}

export default Activity
